/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { INavigationMenuViewProps } from './citta-category-navigation-menu';

const NavigationMenuView: React.FC<INavigationMenuViewProps> = props => {
  const { isMobileView, Navigation, links, pageType} = props;
  if (pageType !== 'Category') {
    return null;
  }
  return (
    <Module {...Navigation} className={classnames(Navigation.className, isMobileView ? 'child' : 'parent')}>
      {links}
    </Module>
  );
};

export default NavigationMenuView;